import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight, Phone, Mail } from 'lucide-react';
import { motion } from 'framer-motion';
export function Footer() {
  const cities = ['Grapevine', 'Colleyville', 'Southlake', 'Coppell', 'Euless', 'Irving', 'Bedford', 'Hurst', 'Trophy Club', 'Flower Mound', 'Lewisville', 'North Richland Hills', 'Keller', 'Las Colinas', 'Westlake'];
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-neutral-900 text-white" data-id="element-47">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16" data-id="element-48">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-49">
          {/* Business Info */}
          <div data-id="element-50">
            <div className="flex items-center gap-3 mb-6" data-id="element-51">
              {' '}
              <img src="https://teamnta.com/static/media/NTALogo.af175f97cd430c154b02.webp" alt="NTA Taekwondo Logo" className="h-10 w-auto" data-id="element-52" />
              <span className="font-black text-xl" data-id="element-53">NTA Taekwondo</span>
            </div>
            <div className="text-gray-400 space-y-3" data-id="element-54">
              <p className="flex items-start gap-2" data-id="element-55">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5 text-red-600" data-id="element-56" />
                <span data-id="element-57">
                  3000 Grapevine Mills Pkwy
                  <br data-id="element-58" />
                  Grapevine, Texas 76051
                </span>
              </p>
              <a href="tel:9725323400" className="flex items-center gap-2 hover:text-red-600 transition-colors" data-id="element-59">
                <Phone className="w-5 h-5 text-red-600" data-id="element-60" />
                (972) 532-3400
              </a>
              <a href="mailto:ntataekwondo@gmail.com" className="flex items-center gap-2 hover:text-red-600 transition-colors" data-id="element-61">
                <Mail className="w-5 h-5 text-red-600" data-id="element-62" />
                ntataekwondo@gmail.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-63">
            <h3 className="font-bold text-lg mb-6 text-white" data-id="element-64">Quick Links</h3>
            <nav className="flex flex-col gap-3" data-id="element-65">
              <Link to="/" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-66">
                Home
              </Link>
              <button onClick={() => scrollToSection('programs')} className="text-gray-400 hover:text-red-600 transition-colors text-left" data-id="element-67">
                Programs
              </button>
              <button onClick={() => scrollToSection('reviews')} className="text-gray-400 hover:text-red-600 transition-colors text-left" data-id="element-68">
                Reviews
              </button>
              <Link to="/contact" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-69">
                Contact
              </Link>
              <Link to="/signup" className="text-gray-400 hover:text-red-600 transition-colors font-semibold" data-id="element-70">
                Easy Class Signup
              </Link>
            </nav>
          </div>

          {/* Service Area */}
          <div className="lg:col-span-2" data-id="element-71">
            <h3 className="font-bold text-lg mb-6 text-white" data-id="element-72">
              Areas We Serve
            </h3>
            <p className="text-gray-400 mb-4 leading-relaxed" data-id="element-73">
              We proudly serve families throughout Grapevine and the surrounding
              communities.
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-74">
              {cities.map(city => <span key={city} className="px-2 py-1 bg-neutral-800 rounded text-xs text-gray-300" data-id="element-75">
                  {city}
                </span>)}
            </div>
          </div>
        </div>

        {/* Final CTA Section */}
        <div className="border-t border-neutral-800 pt-12" data-id="element-76">
          <div className="bg-red-700 rounded-xl p-8 md:p-10 text-center max-w-3xl mx-auto" data-id="element-77">
            <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-78">
              Ready to Get Started?
            </h3>
            <Link to="/signup" data-id="element-79">
              <motion.div whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="inline-flex items-center justify-center px-8 py-4 bg-white text-red-700 font-bold uppercase tracking-wide rounded-sm hover:bg-gray-100 transition-colors shadow-lg" data-id="element-80">
                Easy Class Signup
                <ArrowRight className="ml-2 h-5 w-5" strokeWidth={3} data-id="element-81" />
              </motion.div>
            </Link>
          </div>
        </div>
      </div>

      {/* Legal / Closing */}
      <div className="border-t border-neutral-800 py-6" data-id="element-82">
        <div className="container mx-auto px-4 text-center" data-id="element-83">
          <p className="text-sm text-gray-500" data-id="element-84">
            © NTA Taekwondo. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}